module.exports = __webpack_public_path__ + "img/gift_top-purple_podium.94888244.png";